export const RESET_SURVEY = 'RESET_SURVEY';
